import { JSX } from "react";
import {
    EmptyState,
    OrderHistoryCard,
    OrderHistoryList,
} from "@hatch-digital-nl/bravilor-storybook";
import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useGetOrderHistoryQuery } from "../../../common/api/refurbished";
import { mapOrderHistoryToCardProps } from "../../../common/utils/mapOrderHistoryToCardProps";
import { ReactComponent as CycleSvg } from "../../../common/svgs/cycle.svg";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const OrderHistoryTab = (): JSX.Element => {
    const userData = useGetUserInfoQuery();
    const { activeLanguage } = userData?.data || { activeLanguage: null };

    const { t, isLoading: isTranslationsLoading } = useStringTranslation();
    const {
        data: orderHistoryResponse,
        isLoading: isOrderHistoryLoading,
        isFetching: isOrderHistoryFetching,
    } = useGetOrderHistoryQuery();

    const translationsLoaded = !isTranslationsLoading && !!activeLanguage;
    const isLoading =
        !translationsLoaded || isOrderHistoryLoading || isOrderHistoryFetching;

    const orders = orderHistoryResponse?.data ?? [];

    const labels = translationsLoaded
        ? {
              orderNumberLabel: t("order-history-order-number"),
              orderDateLabel: t("order-history-order-date"),
              serialNrLabel: t("serial-number"),
              priceLabel: t("price"),
              canceledLabel: t("order-history-canceled"),
              emptyTitle: t("order-history-empty-title"),
              emptyDescription: t("order-history-empty-description"),
          }
        : null;

    return (
        <div className="c-account-content c-account-content--order-history">
            {isLoading ? (
                <OrderHistoryList>
                    <div className="c-order-history__card">
                        <div className="skeleton skeleton-title"></div>
                        <div className="skeleton skeleton-name"></div>
                    </div>
                </OrderHistoryList>
            ) : orders.length === 0 && labels ? (
                <div className="c-order-history__empty">
                    <EmptyState
                        Icon={CycleSvg}
                        title={labels.emptyTitle}
                        description={labels.emptyDescription}
                    />
                </div>
            ) : (
                <OrderHistoryList>
                    {orders.map((order) => (
                        <OrderHistoryCard
                            key={order.id}
                            {...mapOrderHistoryToCardProps(
                                order,
                                activeLanguage,
                                labels!,
                            )}
                        />
                    ))}
                </OrderHistoryList>
            )}
        </div>
    );
};
